import EPermissionTypes from 'enums/permissionTypes';

import { useReduxSelector } from 'hooks/redux/useReduxSelector';

import authSelectors from 'store/slices/auth/selectors';

interface IAccessControl {
  allowRoles?: string[];
  children: JSX.Element | React.ReactNode | null;
  permission?: string;
}

const AccessControl = ({
  allowRoles,
  children,
  permission,
}: IAccessControl) => {
  const profile = useReduxSelector(authSelectors.profile);
  const userRole = profile.role;

  // check if user has access to component based on role
  if (allowRoles) {
    if (allowRoles.includes(userRole as string)) {
      // check if role has permission to view component
      switch (permission) {
        case EPermissionTypes.CompanyDetails:
          return profile.company_details ? <>{children}</> : null;
        case EPermissionTypes.UserManagement:
          return profile.user_management ? <>{children}</> : null;
        case EPermissionTypes.InvoicePermission:
          return profile.invoice_permission ? <>{children}</> : null;
        case EPermissionTypes.AllInterventions:
          return profile.all_interventions ? <>{children}</> : null;
        default:
          return <>{children}</>;
      }
    }
  }
  return null;
};

export default AccessControl;
